import {Component, Input} from '@angular/core';

@Component({
  selector: 'achoo-kpi-report-item',
  templateUrl: './achoo-kpi-report-item.component.html',
  styleUrls: ['./achoo-kpi-report-item.component.scss']
})
export class AchooKpiReportItemComponent {
  @Input()
  public kpiLabel: number;

  @Input()
  public kpiValue: number;

  @Input()
  public kpiStatus: number;

  @Input()
  public kpiPercent: number;

  @Input()
  public kpiDescription: string;

  @Input()
  public showKpiStatus = true;

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-kpi-report-item/achoo-kpi-report-item.component.ts